const [{ default: shadowMix }, { default: cart }] = await Promise.all([
	importMod("shadow-mixin"),
	importMod("cart"),
]);

export default class CartAddons extends shadowMix(HTMLElement) {
	#abortListeners = new AbortController();
	connectedCallback() {
		super.connectedCallback();
		const cards = new Map(
			[...this.shadow.querySelectorAll("[data-variant-id]")].map((el) => [
				+el["dataset"].variantId,
				/** @type {HTMLElement} */ (el),
			])
		);

		const cartUpdateHandler = async () => {
			/** @type {Set<number>} */
			const cartItemIds = new Set(
				cart.data.items.map((item) => item.variant_id)
			);
			const cardEntries = [...cards.entries()];
			const addonIds = cardEntries
				.map(([id]) => id)
				.filter((id) => !cartItemIds.has(id)); // all addon ids that are not in the cart
			const visibleCards = cardEntries.filter(([, card]) => !card.hidden);
			const hiddenCards = cardEntries.filter(([, card]) => card.hidden);
			visibleCards.push(...hiddenCards.slice(0, 2 - visibleCards.length)); // show at least 2 cards
			const idsToShow = new Set();
			for (const [id] of visibleCards) {
				if (cartItemIds.has(id)) {
					if (addonIds.length) {
						const index = addonIds.length
							? Math.floor(Math.random() * addonIds.length)
							: 0;
						idsToShow.add(addonIds[index]);
						addonIds.splice(index, 1);
					}
				} else {
					idsToShow.add(id);
				}
			}
			for (const [id, card] of cards) {
				card.hidden = !idsToShow.has(id);
			}

			this.hidden = !idsToShow.size;
		};

		cartUpdateHandler();
		cart.addEventListener("update", cartUpdateHandler, {
			signal: this.#abortListeners.signal,
		});
	}

	disconnectedCallback() {
		this.#abortListeners.abort();
		this.#abortListeners = new AbortController();
	}
}

customElements.define("cart-addons", CartAddons);
